import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled, { css } from 'styled-components';

import BagName from 'common/illustrations/BagName';

type Props = {
  children?: React.ReactNode;
  useNarrowMarginBlockStart?: boolean;
};

const Root = styled.div<{ useNarrowMarginBlockStart?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 648px;
  margin: 0 auto;
  ${({ useNarrowMarginBlockStart }) => css`
    margin-block-start: ${useNarrowMarginBlockStart ? '40px' : '80px'};
  `};
  margin-block-end: 80px;
  padding-inline-start: 32px;
  padding-inline-end: 32px;
  background-color: ${cssThemedValue('surfaceMain')};

  @media (width <= 640px) {
    width: 100%;
    text-align: center;
    padding-inline-start: 16px;
    padding-inline-end: 16px;
  }
`;

const StyledArtboardIllustration = styled(BagName)`
  z-index: 0;
  position: fixed;
  bottom: -12px;
  left: -24px;
  width: 400px;

  @media (width <= 640px) {
    display: none;
  }
`;

const FrontPageTemplate = ({ children, useNarrowMarginBlockStart }: Props) => {
  return (
    <Root useNarrowMarginBlockStart={useNarrowMarginBlockStart}>
      {children}
      <StyledArtboardIllustration />
    </Root>
  );
};

export default FrontPageTemplate;
